// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Hz8p","header":"PatientBlock_header__3vzMS","label":"PatientBlock_label__246r-","option":"PatientBlock_option__1SfBT"};